/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import BaseObject from "@shared/BaseObject.js";
import ScheduledEvent from "@shared/scheduler/ScheduledEvent";
import {Type} from "class-transformer";
import {classToClass} from "@qwoach/class-transformer-wrapper";
import EventType from "@shared/scheduler/EventType";
import CoachingSessionStep from "@shared/Program/ProgramStep/CoachingSessionStep";



export class ProgramSessionWrapper extends BaseObject{

	@Type(_ => CoachingSessionStep)
	programStep: CoachingSessionStep = null;

	@Type(_ => CoachingSessionStep)
	programStepOriginal:  CoachingSessionStep = null;

	@Type(_ => ScheduledEvent)
	sessionItem: ScheduledEvent = null;

	@Type(_ => EventType)
	sessionType: EventType = null;

	isFormerSessionSaved: boolean = false

	constructor(programStep: CoachingSessionStep = null, sessionItem: ScheduledEvent = null, sessionType: EventType = null) {
		super();
		this.programStep = programStep;
		this.sessionItem = sessionItem;
		this.sessionType = sessionType;
	}

	fillSessionFromStep(){
		console.log("fillSessionFromStep: this = ", this)
		if(this.sessionItem){
			if(this.sessionType) this.sessionItem.fillFromSessionType(this.sessionType)
			this.sessionItem.fillAnswersFromCallStep(this.programStep)
		}
	}

	saveFormerSession(){
		//be careful: this method is not idempotent - calling it twice in a row will result in overriding formerEvent with "this" event
		if(this.sessionItem && !this.isFormerSessionSaved){
			this.isFormerSessionSaved = true
			let formerSessionItem = classToClass(this.sessionItem)
			formerSessionItem.formerEvent = null
			this.sessionItem.formerEvent = formerSessionItem
			console.log("saveFormerSession is set: this.sessionItem = ", this.sessionItem)
		}
	}

	fillStepFromDiff(stepNew, stepOld){
		let res = false
		let object = stepOld || {}
		Object.keys(object).forEach(key => {
			if(key !== "id" && key !== "createdAt"){
				let valOld = stepOld[key]
				let valNew = stepNew[key]

				if(!this.equalsInternal(valNew, valOld)){
					console.log("fillStepFromDiff: key = ", key, ", valNew = ", valNew, ", valOld = ", valOld)
					this.programStep[key] = classToClass(valNew)
					res = true
				}
			}
		})
		return res
	}

}
